<template>
  <div class="expand">
    <el-table border fit highlight-current-row :data="data" class="customer-table" ref="tableRef" size="small">
      <el-table-column label="采购地址" prop="gongyingshang"></el-table-column>
      <el-table-column label="采购单价" prop="cgprice"></el-table-column>
      <el-table-column label="采购数量" prop="number"></el-table-column>
      <el-table-column label="采购总价" prop="cgzprice"></el-table-column>
      <el-table-column label="是否开票" prop="sfkp">
        <template slot-scope="scope">
          {{ scope.row.sfkp == 1 ? '已开' : scope.row.sfsp == 2 ? '未税' : '未开' }}
        </template>
      </el-table-column>
      <el-table-column label="收票状态" prop="sfsp">
        <template slot-scope="scope">
          {{ scope.row.sfsp == 1 ? '已到' : scope.row.sfsp == 2 ? '未到' : '未税' }}
        </template>
      </el-table-column>
      <el-table-column label="开票发票号" prop="kpfph"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template v-slot="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope)"
                     class="el-icon-edit-outline"
          >
            编辑
          </el-button>
          <el-popconfirm
            iconColor="red"
            @confirm="handleDelete(scope, scope.$index)"
            title="确认删除此条数据吗？"
          >
            <el-button slot="reference" size="mini" class="el-icon-delete" type="danger">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <Edit :dialog="editDialog" :form-data="editFormData" @submit="handleSubmit"
          @close="handleClose" :submitLoading="submitLoading" />
  </div>
</template>
<script>
import { defineComponent, ref, inject, getCurrentInstance } from '@vue/composition-api'
import Edit from './edit.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'

export default defineComponent({
  name: 'expand',
  components: { Edit },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    parentId: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const editFormData = ref({})
    const editDialog = ref(false)
    const submitLoading = ref(false)
    const keyId = ref()
    const handleEdit = (scope) => {
      editDialog.value = true
      editFormData.value = { ...editFormData.value, ...scope.row }
      keyId.value = scope.row.id
    }
    const handleDelete = (scope, index) => {
      request({
        url: 'purchase_delete.yy',
        method: 'post',
        data: { id: scope.row.id }
      }).then(res => {
        if (res.code == 200) deleteRow(scope.row.id)
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }

    const deleteRow = (childId) => {
      emit('deleteRow', {
        parentId: props.parentId,
        childId
      })
    }


    const handleSubmit = (form) => {
      submitLoading.value = true
      request({
        url: 'purchase_update.yy',
        method: 'post',
        data: { id: keyId.value, ...form }
      }).then(res => {
        if (res.code == 200) {
          submitLoading.value = false
          editDialog.value = false
          emit('updateExpand')
        }
      })
    }

    const handleClose = () => {
      editDialog.value = false
      editFormData.value = {}
    }

    return {
      editFormData,
      submitLoading,
      editDialog,
      handleEdit,
      handleDelete,
      handleClose,
      handleSubmit
    }
  }
})
</script>
<style scoped lang="scss">
.expand {
  margin: 0 20px;

  .el-icon-delete {
    margin-left: 10px;
  }
}
</style>
